

<template>
 <div>
   <div  class="scroll-container">
     <el-form :model="personaForm" ref="queryForm" size="small"  :rules="rulesTest" label-width="160px" class="elFromClass">

       <el-form-item label="公司名称:" prop="unitName"  style="font-size: 20px" class="fromItem">
         <el-input
             v-model="personaForm.corporateName"
             placeholder="请输入公司名称"
             clearable
             class="inputFrom"
         />
       </el-form-item>
       <el-form-item label="项目名称:" prop="unitName" class="fromItem">
         <el-input
             v-model="personaForm.entryName"
             placeholder="请输入项目名称"
             clearable
         />
       </el-form-item>

       <el-form-item label="项目介绍" prop="unitName" class="fromItem">
         <el-input
             v-model="personaForm.projectIntroduction"
             placeholder="请输入项目介绍(格式为用了xxx技术，实现了XXX功能，目的为了XXXX)"
             clearable
             type="textarea"
         />
       </el-form-item>


       <el-form-item label="主要分工："  prop="division" class="fromItem">
         <el-input
             v-model="personaForm.division"
             placeholder="请输入主要分工"
             clearable
         />
       </el-form-item>
     </el-form>

   </div>

   <div slot="footer" class="dialog-footer">
     <el-button type="primary" @click="submitForm">提交申报</el-button>
     <!--       <el-button @click="cancel">取 消</el-button>-->
   </div>
 </div>
</template>

<script >
export default {
  data() {
    return {
      personaForm: {
        corporateName: '',
        entryName: '',
        projectIntroduction: ''
      },


    }
  },

  methods:{

  }
}
</script>

<style scoped lang="scss">

.scroll-container{
  height: 400px;
  max-height: 500px; /* 最大高度，超出时滚动 */
  overflow-y: auto; /* 纵向滚动条 */
  overflow-x: hidden; /* 禁止横向滚动条 */
  border: 1px solid #ddd; /* 可选，视觉边框 */
  padding: 10px; /* 内边距 */
  background-color: #f9f9f9; /* 可选，背景颜色 */
  margin-top: 20px;
}
.elFromClass{
  //display: flex; /* 确保每个字段占一行 */
  margin-bottom: 20px;
}
 ::v-deep .inputFrom{
  width: 100%;
  height: 50px !important;
}
.fromItem{
  margin-bottom: 10px;
  margin-top: 10px;
}
::v-deep .el-form-item__label{
  font-size: 20px !important;
}
.dialog-footer{
  margin-top: 20px;
}
</style>
